<template>
  <div class="home-body">
    <div class="container xs-pt-30 xs-pb-50">
      <h1 class="serif">Feedback Form</h1>
      <br />
      <InquiryForm subject="Feedback form"></InquiryForm>
    </div>
  </div>
</template>


<script>
import _ from 'underscore'
  import InquiryForm from '../home/InquiryForm'


export default {
    components: {
      InquiryForm
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body { background: #FFFFFF; }
</style>



// WEBPACK FOOTER //
// FeedbackFormPage.vue?57b0ebbc